export const configuration = {
    role: ['manager', 'administrator'],
    show: false,
    showOtherSync: false, // historical fields not used for ubolino
    showUploadExercice: true, // is done for ubolino from downloading
    uploadExoConfig: {maxSize: 200, formatAllowed: ['.zip', '.csv'], pathDownload: 'https://preprod.lms.api.tralalere.com/en/file/8279/download?token=V-4DYWYd'}
};
